import React from 'react';
import { useLingui } from '@lingui/react';

export default function Person(
    props: React.SVGProps<SVGSVGElement>,
): React.JSX.Element {
    const { i18n } = useLingui();
    return (
        <svg
            width="94"
            height="92"
            viewBox="0 0 94 92"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <title>
                {i18n.t({
                    id: 'privacy-settings.svg.person.title',
                    comment: 'Person SVG title',
                })}
            </title>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.2381 -0.000205994L0.583252 81.0414L82.3463 92.0002L93.4167 10.934L10.2381 -0.000205994Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.0861 3.62359L4.1936 78.2649L79.5011 88.3593L89.6967 13.6941L13.0861 3.62359Z"
                fill="#E8EEF4"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M46.4998 32.3288C45.3465 40.4249 37.8501 46.0533 29.754 44.9009C21.6571 43.7485 16.0286 36.2503 17.181 28.1543C18.3343 20.0582 25.8307 14.4297 33.9277 15.5822C42.0237 16.7346 47.6531 24.2327 46.4998 32.3288Z"
                fill="#7CDFFF"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.913 63.837L72.8785 71.2968L72.1119 76.1741L15.465 68.2535L15.913 63.837ZM17.567 52.8536L74.2148 60.7742L73.7659 65.1906L16.8005 57.7308L17.567 52.8536ZM52.6767 36.3547L73.3542 38.9628L72.7376 43.2983L52.3283 40.7848L52.6767 36.3547ZM53.8545 25.6202L77.9826 28.7198L77.3659 33.0553L53.553 30.0562L53.8545 25.6202Z"
                fill="#C3CCD9"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.6594 39.1034C22.6594 39.1034 26.3868 34.0294 30.9574 34.6802C35.5279 35.3309 37.6361 41.5122 37.6361 41.5122C37.6361 41.5122 34.5757 43.4772 29.8356 42.8026C25.0955 42.1272 22.6594 39.1034 22.6594 39.1034ZM27.1379 23.705C28.4487 18.2426 36.1342 18.2801 37.5661 23.717C38.8573 28.6197 34.1769 33.2082 32.5807 33.1938C31.188 33.181 25.7571 29.4596 27.1379 23.705Z"
                fill="#06BEFB"
            />
        </svg>
    );
}
